// src/reducers/collectionReducer.js
import {
  FETCH_COLLECTIONS_REQUEST,
  FETCH_COLLECTIONS_SUCCESS,
  FETCH_COLLECTIONS_FAILURE,
  CREATE_COLLECTION_REQUEST,
  CREATE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_FAILURE,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_FAILURE,
  DELETE_COLLECTION_REQUEST,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAILURE,
} from "../actions/types";

const initialState = {
  collections: [],
  loading: false,
  error: null,
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COLLECTIONS_REQUEST:
    case CREATE_COLLECTION_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_COLLECTION_REQUEST:
    case DELETE_COLLECTION_REQUEST:
      return { ...state, error: null };

    case FETCH_COLLECTIONS_SUCCESS:
      return { ...state, loading: false, collections: action.payload };

    case CREATE_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: [...state.collections, action.payload],
      };

    case UPDATE_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: state.collections.map((c) =>
          c.slug === action.payload.slug ? { ...c, ...action.payload } : c
        ),
      };

    case DELETE_COLLECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: state.collections.filter((c) => c.slug !== action.payload),
      };

    case FETCH_COLLECTIONS_FAILURE:
    case CREATE_COLLECTION_FAILURE:
    case UPDATE_COLLECTION_FAILURE:
    case DELETE_COLLECTION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default collectionReducer;
